import { render, staticRenderFns } from "./areaAdjust.vue?vue&type=template&id=b3073562&scoped=true"
import script from "./areaAdjust.vue?vue&type=script&lang=js"
export * from "./areaAdjust.vue?vue&type=script&lang=js"
import style0 from "./areaAdjust.vue?vue&type=style&index=0&id=b3073562&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3073562",
  null
  
)

export default component.exports